import { PropsWithChildren, useState } from 'react';

import { createSafeContext } from 'core/Utils';

type MapContext = {
  id: string;
  mapArea: { lat: number; lng: number };
  setMapArea: (value: { lat: number; lng: number }) => void;
};

const [_MapProvider, _useMapContext] = createSafeContext<MapContext>(
  'Map Context component was not found in tree'
);

interface MapProviderProps extends PropsWithChildren {
  /**
   * The ID of the map, this is used to identify the map when using multiple maps
   */
  id: string;
  latlng?: { lat: number; lng: number };
}
const MapProvider = ({ id, children }: MapProviderProps) => {
  const [mapArea, setMapArea] = useState({ lat: 0, lng: 0 });
  return <_MapProvider value={{ id: id, mapArea, setMapArea }}>{children}</_MapProvider>;
};

export { MapProvider, _useMapContext };
